export const UPDATE_TOUR_STATUS_SUCCESS = 'UPDATE_TOUR_STATUS_SUCCESS';
export const UPDATE_TOUR_STATUS_ERROR = 'UPDATE_TOUR_STATUS_ERROR';

export interface UpdateTourStatusSuccessAction {
    type: typeof UPDATE_TOUR_STATUS_SUCCESS;
    payload: {
        updated: boolean;
    };
}

export interface UpdateTourStatusErrorAction {
    type: typeof UPDATE_TOUR_STATUS_ERROR;
    error: Error;
}

export type UserLaneActionTypes = UpdateTourStatusSuccessAction | UpdateTourStatusErrorAction;
